<template>
  <div class="media-page page-dashboard min-h-screen w-full p-3 md:p-4">
    <div class="flex items-center justify-between mb-3">
      <h2 class="text-lg font-bold">Dashboard</h2>
      <span class="text-xs text-zinc-400 dark:text-zinc-500">Bienvenido(a) {{ name }}</span>
    </div>

    <div v-if="!conectadosData && !error" class="kpi-skel-page">
      <section class="kpi-section mb-5">
        <h3 class="kpi-section-title">
          <i class="pi pi-sync kpi-section-icon kpi-section-icon--live" style="font-size:0.92rem;color:#10b981"></i>
          Conectados
        </h3>
        <KpiSectionSkeleton variant="hero" />
      </section>
    </div>

    <p v-else-if="error" class="text-xs text-red-400 py-2">{{ error }}</p>

    <template v-else>
      <div class="kpi-mus-hero mb-4" :class="heroClass || 'kpi-mus-hero-dimmed'" @click="abrirModalConectados" style="cursor:pointer">
        <div class="kpi-mus-hero-row" style="justify-content:center">
          <div class="kpi-mus-hero-left" style="text-align:center;width:100%">
            <span class="kpi-card-label">
              Sucursales conectadas ahora
              <span v-if="conectadosData" class="kpi-live-dot"></span>
            </span>
            <div class="kpi-mus-hero-pct ds-hero-num" :class="{ 'ds-hero-pop': animando }" style="font-size:2.6rem">
              {{ displayedConectados != null ? displayedConectados.toLocaleString() : (conectadosData?.conectados_ahora?.toLocaleString() ?? '—') }}
            </div>
            <span class="kpi-card-sub-muted" style="display:block;margin-top:2px">
              de {{ conectadosData?.total_sucursales?.toLocaleString() ?? '—' }} sucursales
            </span>
            <div class="kpi-mus-bar-wrap" style="margin:6px auto 0;max-width:280px">
              <div class="kpi-mus-bar-fill" :style="{ width: barPct + '%' }"></div>
            </div>
            <span class="kpi-card-sub-muted" style="display:block;margin-top:4px">
              <i class="pi pi-sync mr-1" style="font-size:0.68rem"></i>actualizado hace {{ segundosDesdeActualizacion }}s
            </span>
          </div>
        </div>
      </div>

      <div class="ds-global-actions">
        <label class="ds-demo-toggle" title="Mostrar canales demo">
          <input type="checkbox" v-model="showDemos" />
          <span class="ds-demo-check"></span>
          <span class="ds-demo-label">Ver demos</span>
        </label>
      </div>

      <div v-for="sec in sections" :key="sec.key" class="kpi-section" style="margin-bottom:10px">
        <div class="cdm-group-section">
          <div class="cdm-group-section-header" @click="toggleSection(sec.key)">
            <svg v-if="sec.key === 'sonara'" width="18" height="18" viewBox="0 0 22 22" style="flex-shrink:0">
              <circle cx="11" cy="11" r="10" fill="#ff0000" stroke="#fff" stroke-width="2"/>
              <circle cx="11" cy="11" r="5" fill="#000" stroke="#fff" stroke-width="2"/>
            </svg>
            <i v-else :class="sec.icon" :style="{ color: sec.iconColor, fontSize: '0.9rem' }"></i>
            <span>{{ sec.label }}</span>
            <span class="cdm-group-section-count">{{ sec.count }} canales</span>
            <i class="pi pi-chevron-down cdm-group-chevron" :class="{ 'is-collapsed': !expanded[sec.key] }"></i>
          </div>
          <transition name="cdm-group-collapse">
            <div v-if="expanded[sec.key]">
              <div class="ds-columns">
                <div v-for="col in columns" :key="col.key" class="ds-col">
                  <div class="ds-col-head" :class="col.headClass">
                    <i :class="col.icon"></i>
                    {{ col.label }}
                    <span class="ds-col-badge">{{ sec[col.key].length }}</span>
                  </div>
                  <div v-if="sec[col.key].length === 0" class="ds-col-empty">{{ col.emptyText }}</div>
                  <div v-for="c in sec[col.key]" :key="c.stream" class="cdm-card cdm-card-channel" :class="'cdm-card--' + col.state" @click="abrirDetalleCanal(c)">
                    <div class="cdm-card-body">
                      <div class="cdm-channel-bar-left" :class="'is-' + col.color"></div>
                      <div class="cdm-channel-logo" :style="logoBackground(c)">
                        <img v-if="getLogoUrl(c)" :src="getLogoUrl(c)" :alt="c.radio_name || ''" class="cdm-channel-logo-img" draggable="false" />
                        <i v-else class="pi pi-megaphone cdm-channel-logo-fallback"></i>
                      </div>
                      <div class="cdm-card-info">
                        <span class="cdm-card-title">{{ c.radio_name }}</span>
                        <span class="ds-plan-indicator">
                          <span class="ds-plan-dot" :class="planClass(c)"></span>{{ planLabel(c) }}
                        </span>
                      </div>
                      <div class="cdm-channel-stats">
                        <div class="cdm-channel-stat-row">
                          <span class="cdm-channel-count" :class="'is-' + col.color">{{ c.conectados.toLocaleString() }}</span>
                          <span class="cdm-channel-sucursales">de {{ c.sucursales || '?' }}</span>
                        </div>
                        <div class="cdm-channel-bar-track">
                          <div class="cdm-channel-bar-fill" :class="'is-' + col.color" :style="{ width: canalPct(c) + '%' }"></div>
                        </div>
                        <div class="cdm-channel-bar-footer">
                          <span v-if="c.sucursales" class="cdm-channel-pct" :class="'is-' + col.color">{{ canalPct(c) }}%</span>
                        </div>
                      </div>
                      <i class="pi pi-chevron-right cdm-card-arrow"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div class="ds-footer">
        <button class="ds-footer-btn" @click="abrirModalConectados">
          <i class="pi pi-chart-bar" style="font-size:0.75rem"></i> Ver detalle completo de conectados
        </button>
      </div>
    </template>

    <ConectadosDetalleModal
      v-model:visible="showModal"
      v-model:initialStream="selectedStream"
      :initialRadioName="selectedRadioName"
      :initialSucursales="selectedSucursales"
      :conectadosAhora="conectadosAhoraPayload"
      :totalSucursalesKpi="conectadosData?.total_sucursales ?? null"
    />
  </div>
</template>

<script>
import axiosInstance from '@/axiosInstance';
import KpiSectionSkeleton from '@/components/KpiSectionSkeleton.vue';
import ConectadosDetalleModal from '@/components/ConectadosDetalleModal.vue';

const EXCLUDED_TYPES = ['intercambio', 'cortesia', 'demo'];
const MAX_POR_COLUMNA = 5;

export default {
  name: 'DashboardPage',
  components: { KpiSectionSkeleton, ConectadosDetalleModal },
  data() {
    return {
      conectadosData: null,
      categoriasMap: new Map(),
      error: null,
      showDemos: false,
      showModal: false,
      selectedStream: null,
      selectedRadioName: null,
      selectedSucursales: null,
      displayedConectados: null,
      animFrameId: null,
      animando: false,
      loading: true,
      timer: null,
      ticker: 0,
      tickerTimer: null,
      name: '',
      expanded: { musica: true, video: false, sonara: false },
      columns: [
        { key: 'criticos', label: 'Crítico', icon: 'pi pi-exclamation-triangle', headClass: 'ds-col-head--red', state: 'critico', color: 'red', emptyText: 'Ningún canal crítico' },
        { key: 'riesgos', label: 'Riesgo', icon: 'pi pi-clock', headClass: 'ds-col-head--yellow', state: 'riesgo', color: 'yellow', emptyText: 'Ningún canal en riesgo' },
        { key: 'optimos', label: 'Óptimo', icon: 'pi pi-check-circle', headClass: 'ds-col-head--green', state: 'optimo', color: 'green', emptyText: 'Ningún canal óptimo' },
      ],
    };
  },
  computed: {
    barPct() {
      const d = this.conectadosData;
      if (!d?.total_sucursales) return 0;
      return Math.min(100, Math.round((d.conectados_ahora / d.total_sucursales) * 100));
    },
    heroClass() {
      const pct = this.barPct;
      if (!this.conectadosData) return null;
      if (pct >= 90) return 'kpi-mus-hero-green';
      if (pct >= 50) return 'kpi-mus-hero-yellow';
      return 'kpi-mus-hero-red';
    },
    canalesFiltrados() {
      if (!this.conectadosData?.canales) return [];
      let arr = this.conectadosData.canales;
      if (!this.showDemos) {
        const lower = (v) => String(v || '').toLowerCase().trim();
        arr = arr.filter((c) => !EXCLUDED_TYPES.includes(lower(c.radio_type)));
      }
      return arr;
    },
    sections() {
      const cols = (arr) => {
        return {
          cs: arr.filter((c) => this.canalPct(c) < 50).sort((a, b) => this.canalPct(a) - this.canalPct(b)).slice(0, MAX_POR_COLUMNA),
          rs: arr.filter((c) => { const p = this.canalPct(c); return p >= 50 && p < 90; }).sort((a, b) => this.canalPct(a) - this.canalPct(b)).slice(0, MAX_POR_COLUMNA),
          os: arr.filter((c) => this.canalPct(c) >= 90).sort((a, b) => this.canalPct(b) - this.canalPct(a)).slice(0, MAX_POR_COLUMNA),
        };
      };

      const base = this.canalesFiltrados;
      const a = base.filter((c) => this.esSonara(c));
      const v = base.filter((c) => !this.esSonara(c) && this.esVideo(c));
      const m = base.filter((c) => !this.esSonara(c) && !this.esVideo(c));

      const mc = cols(m), vc = cols(v), ac = cols(a);

      return [
        { key: 'musica', label: 'Música', icon: 'pi pi-volume-up', iconColor: '#7c3aed', count: m.length, criticos: mc.cs, riesgos: mc.rs, optimos: mc.os },
        { key: 'video', label: 'Video', icon: 'pi pi-video', iconColor: '#a16207', count: v.length, criticos: vc.cs, riesgos: vc.rs, optimos: vc.os },
        { key: 'sonara', label: 'Sonara', icon: '', iconColor: '#dc2626', count: a.length, criticos: ac.cs, riesgos: ac.rs, optimos: ac.os },
      ];
    },
    conectadosAhoraPayload() {
      const d = this.conectadosData;
      if (!d) return null;
      return {
        total: d.conectados_ahora ?? 0,
        total_hoy: d.total_hoy ?? 0,
        total_sucursales: d.total_sucursales ?? 0,
        actualizado_en: d.timestamp ?? null,
        canales: d.canales ?? [],
      };
    },
    segundosDesdeActualizacion() {
      this.ticker;
      const ts = this.conectadosData?.timestamp;
      if (!ts) return '—';
      const diff = Math.floor((Date.now() - new Date(ts).getTime()) / 1000);
      return Math.max(0, diff);
    },
  },
  methods: {
    canalPct(c) {
      if (!c?.sucursales) return 0;
      return Math.min(100, Math.round((c.conectados / c.sucursales) * 100));
    },
    getLogoUrl(row) {
      if (!row?.mobileimage) return null;
      return 'https://vybroo.net/images' + row.mobileimage;
    },
    logoBackground(row) {
      if (!row?.color) return { backgroundColor: '#3f3f46' };
      const hex = String(row.color).replace(/^#/, '').toLowerCase();
      if (/^[0-9a-f]{3}$/.test(hex) || /^[0-9a-f]{6}$/.test(hex)) {
        return { backgroundColor: '#' + hex };
      }
      return { backgroundColor: '#3f3f46' };
    },
    normalizarTipo(tipo) {
      const t = String(tipo || '').toLowerCase().trim();
      const map = { demos: 'demo', 'cortesía': 'cortesia', pruebas: 'demo' };
      return map[t] || t;
    },
    planLabel(c) {
      const t = this.normalizarTipo(c.radio_type);
      if (!t) return 'Activo';
      if (t === 'intercambio') return 'Intercambio';
      if (t === 'cortesia') return 'Cortesía';
      if (t === 'demo') return 'Demo';
      return t;
    },
    planClass(c) {
      const t = this.normalizarTipo(c.radio_type);
      if (!t) return 'is-active';
      if (t === 'intercambio') return 'is-intercambio';
      if (t === 'cortesia') return 'is-cortesia';
      if (t === 'demo') return 'is-demo';
      return 'is-active';
    },
    esVideo(c) {
      const cat = this.categoriasMap.get(c.stream);
      if (cat !== undefined) return cat.esVideo;
      const check = (v) => v && typeof v === 'string' && v.toLowerCase().includes('video');
      return check(c.stream) || check(c.radio_name);
    },
    esSonara(c) {
      const cat = this.categoriasMap.get(c.stream);
      if (cat !== undefined) return cat.sonara;
      return false;
    },
    toggleSection(key) {
      this.expanded[key] = !this.expanded[key];
    },
    async cargarCategorias() {
      try {
        const token = localStorage.getItem('token');
        const res = await axiosInstance.post('/api/connectionmonitor', { token });
        const brands = (res.data && res.data.data) ? res.data.data : [];
        const map = new Map();
        brands.forEach((b) => {
          map.set(b.stream, {
            sonara: !!(b.sonara || (b.link && typeof b.link === 'string' && b.link.toLowerCase().includes('sonara'))),
            esVideo: !!(b.is_video || b.isVideo || b.video || b.video_enabled || b.videoEnabled || b.hasVideo || b.has_video || b.tiene_video || b.id_video_youtube || (b.stream && typeof b.stream === 'string' && b.stream.toLowerCase().includes('video')) || (b.link && typeof b.link === 'string' && b.link.toLowerCase().includes('video')) || (b.name && typeof b.name === 'string' && b.name.toLowerCase().includes('video'))),
          });
        });
        this.categoriasMap = map;
      } catch (_) {
        // fallback: all canales treated as Musica
      }
    },
    async cargarConectados() {
      try {
        const token = localStorage.getItem('token');
        const res = await axiosInstance.get('/api/kpi_ops_conectados_ahora', {
          params: { token },
        });
        const body = res?.data || {};
        const payload = (body && typeof body.data === 'object' && body.data !== null) ? body.data : body;
        if (!body.success && !body.ok && body.error) {
          this.error = body.message || body.msg || 'Error al cargar conectados';
          return;
        }
        this.conectadosData = payload;
        this.error = null;
      } catch (e) {
        this.error = 'Error de conexi&oacute;n al cargar conectados.';
      } finally {
        this.loading = false;
      }
    },
    abrirModalConectados() {
      this.selectedStream = null;
      this.selectedRadioName = null;
      this.selectedSucursales = null;
      this.showModal = true;
    },
    abrirDetalleCanal(c) {
      this.selectedStream = c.stream;
      this.selectedRadioName = c.radio_name;
      this.selectedSucursales = c.sucursales || null;
      this.showModal = true;
    },
    animarNumero(desde, hasta) {
      if (this.animFrameId) cancelAnimationFrame(this.animFrameId);
      if (desde === hasta) { this.displayedConectados = hasta; return; }
      this.animando = true;
      const duracion = 1500;
      const inicio = performance.now();
      const paso = (ahora) => {
        const t = Math.min((ahora - inicio) / duracion, 1);
        const ease = t >= 1 ? 1 : (-Math.pow(2, -10 * t) + 1) * 1024 / 1023;
        this.displayedConectados = Math.round(desde + (hasta - desde) * ease);
        if (t < 1) this.animFrameId = requestAnimationFrame(paso);
        else { this.displayedConectados = hasta; this.animando = false; }
      };
      this.animFrameId = requestAnimationFrame(paso);
    },
  },
  watch: {
    'conectadosData.conectados_ahora'(nuevo) {
      if (nuevo == null) return;
      const desde = typeof this.displayedConectados === 'number' ? this.displayedConectados : 0;
      this.displayedConectados = desde;
      this.$nextTick(() => this.animarNumero(desde, nuevo));
    },
  },
  mounted() {
    try {
      if (localStorage.getItem('clientData')) {
        const tokenId = JSON.parse(localStorage.getItem('clientData'));
        this.name = tokenId.name || '';
      }
    } catch (_e) { /* ignore */ }
    this.cargarConectados();
    this.cargarCategorias();
    this.timer = setInterval(() => this.cargarConectados(), 30000);
    this.tickerTimer = setInterval(() => { this.ticker++; }, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
    clearInterval(this.tickerTimer);
    if (this.animFrameId) cancelAnimationFrame(this.animFrameId);
  },
};
</script>

<style>
.page-dashboard {
  --ds-green: #10b981;
  --ds-yellow: #f59e0b;
  --ds-red: #ef4444;
}

/* ─── Global actions row ─── */
.ds-global-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

/* ─── Demo toggle ─── */
.ds-demo-toggle {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-color-secondary, #64748b);
  user-select: none;
}
.dark .ds-demo-toggle { color: #a1a1aa; }
.ds-demo-toggle input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.ds-demo-check {
  position: relative;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1.5px solid rgba(148, 163, 184, 0.45);
  background: rgba(248, 250, 252, 0.9);
  flex-shrink: 0;
  transition: background 0.15s, border-color 0.15s;
}
.dark .ds-demo-check {
  background: rgba(39, 39, 42, 0.5);
  border-color: rgba(82, 82, 91, 0.45);
}
.ds-demo-toggle input:checked + .ds-demo-check {
  background: #3b82f6;
  border-color: #3b82f6;
}
.ds-demo-toggle input:checked + .ds-demo-check::after {
  content: '';
  position: absolute;
  left: 4px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.ds-demo-label { white-space: nowrap; }

/* ─── 3 columns ─── */
.ds-columns {
  display: flex;
  gap: 12px;
  align-items: stretch;
}
@media (max-width: 820px) {
  .ds-columns { flex-direction: column; }
}
.ds-col {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

/* ─── Column header ─── */
.ds-col-head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 700;
  padding: 8px 10px;
  border-radius: 8px 8px 0 0;
  margin-bottom: 0;
  border-bottom: 2px solid transparent;
}
.ds-col-head i { font-size: 0.75rem; }
.ds-col-head--red    { color: #991b1b; border-bottom-color: var(--ds-red);    background: rgba(239, 68, 68, 0.04); }
.ds-col-head--yellow { color: #92400e; border-bottom-color: var(--ds-yellow); background: rgba(245, 158, 11, 0.04); }
.ds-col-head--green  { color: #065f46; border-bottom-color: var(--ds-green);  background: rgba(16, 185, 129, 0.04); }
.dark .ds-col-head--red    { color: #fca5a5; background: rgba(239, 68, 68, 0.07); }
.dark .ds-col-head--yellow { color: #fcd34d; background: rgba(245, 158, 11, 0.07); }
.dark .ds-col-head--green  { color: #6ee7b7; background: rgba(16, 185, 129, 0.07); }

.ds-col-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 99px;
  font-size: 0.7rem;
  font-weight: 700;
  margin-left: auto;
}
.ds-col-head--red    .ds-col-badge { background: rgba(239, 68, 68, 0.12); color: #991b1b; }
.ds-col-head--yellow .ds-col-badge { background: rgba(245, 158, 11, 0.12); color: #92400e; }
.ds-col-head--green  .ds-col-badge { background: rgba(16, 185, 129, 0.12); color: #065f46; }
.dark .ds-col-head--red    .ds-col-badge { background: rgba(239, 68, 68, 0.18); color: #fca5a5; }
.dark .ds-col-head--yellow .ds-col-badge { background: rgba(245, 158, 11, 0.18); color: #fcd34d; }
.dark .ds-col-head--green  .ds-col-badge { background: rgba(16, 185, 129, 0.18); color: #6ee7b7; }

/* ─── Empty state ─── */
.ds-col-empty {
  text-align: center;
  padding: 24px 10px;
  font-size: 0.78rem;
  color: var(--text-color-secondary, #94a3b8);
  font-style: italic;
}

/* ─── Plan indicator on cards ─── */
.ds-plan-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.65rem;
  font-weight: 500;
  color: var(--text-color-secondary, #94a3b8);
  line-height: 1.2;
  margin-top: 1px;
}
.dark .ds-plan-indicator { color: #71717a; }
.ds-plan-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
.ds-plan-dot.is-active     { background: #22c55e; }
.ds-plan-dot.is-demo       { background: #6b7280; }
.ds-plan-dot.is-intercambio { background: #eab308; }
.ds-plan-dot.is-cortesia   { background: #a855f7; }
.ds-plan-dot.is-pruebas    { background: #f97316; }

/* ─── Footer button ─── */
.ds-footer {
  text-align: center;
  padding-top: 16px;
}
.ds-footer-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: 8px;
  border: 1px solid var(--surface-border, #e2e8f0);
  background: var(--surface-card, #fff);
  color: var(--text-color, #1e293b);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}
.dark .ds-footer-btn {
  background: rgba(255,255,255,0.03);
  border-color: rgba(255,255,255,0.08);
  color: #e4e4e7;
}
.ds-footer-btn:hover {
  border-color: var(--primary-color, #3b82f6);
  background: rgba(59,130,246,0.04);
}
.dark .ds-footer-btn:hover {
  border-color: var(--primary-color, #60a5fa);
  background: rgba(59,130,246,0.08);
}

/* ─── Hero number animation ─── */
.ds-hero-num {
  transition: transform 0.15s;
}
.ds-hero-pop {
  animation: ds-pop 0.35s ease-out;
}
@keyframes ds-pop {
  0% { transform: scale(1); }
  35% { transform: scale(1.07); }
  70% { transform: scale(0.97); }
  100% { transform: scale(1); }
}
</style>
